import { ProjectPhoto } from '@/app/api';

export const isImageLandscapeOriented = (image: ProjectPhoto) => {
  return image.width > image.height;
};
